import { Injectable, InjectionToken } from '@angular/core';

import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { getDateFromNumericFormat } from '../date-format/date-format.helper';
import { NumericDateFormatPipe } from '../date-format/numeric-date-format.pipe';
import { EnvironmentService } from '../environment/environment.service';

import { CLOUD_DATE_FORMAT } from './datepicker-adapter.service';

export const DATEPICKER_PARSER_FORMATTER = new InjectionToken<NgbDateParserFormatter>(
  'shrd.uic.DatepickerParserFormatter'
);

/**
 * Transform from/to datepicker-internal format to the one used e.g. for displaying the value in the bound input field.
 */
@Injectable()
export class DatepickerParserFormatterService implements NgbDateParserFormatter {
  private readonly dateFormat: string;

  constructor(envService: EnvironmentService, private readonly dateFormatPipe: NumericDateFormatPipe) {
    this.dateFormat = envService.dateFormat || CLOUD_DATE_FORMAT;
  }

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = getDateFromNumericFormat(value, this.dateFormat);
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? this.dateFormatPipe.transform(new Date(date.year, date.month - 1, date.day), this.dateFormat) : '';
  }
}
